/* Native server-rendered gift selections. Safe to reinitialize in Theme Editor. */
(() => {
  function initialize(scope) {
    const section = scope.querySelector('.claude-products');
    if (!section || section.dataset.homeReady || !section.querySelector('.product-tabs')) return;
    section.dataset.homeReady = 'true';
    const tabs = Array.from(section.querySelectorAll('[data-group]'));
    const panels = Array.from(section.querySelectorAll('[data-home-panel]'));
    const shortcuts = Array.from(section.closest('.sv-home-content').querySelectorAll('[data-budget]'));
    const heading = section.querySelector('#products-title');
    const collectionLink = section.querySelector('#collection-link');
    function select(group) {
      const panel = panels.find(el => el.dataset.homePanel === group);
      if (!panel) return;
      panels.forEach(el => { el.hidden = el !== panel; });
      tabs.forEach(el => { const active = el.dataset.group === group; el.setAttribute('aria-selected', String(active)); el.tabIndex = active ? 0 : -1; });
      shortcuts.forEach(el => { if (el.dataset.budget === group) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
      heading.textContent = panel.dataset.title;
      collectionLink.textContent = panel.dataset.collectionLabel;
      collectionLink.href = panel.dataset.collectionUrl;
    }
    tabs.forEach(el => el.addEventListener('click', () => select(el.dataset.group)));
    shortcuts.forEach(el => el.addEventListener('click', () => select(el.dataset.budget)));
    section.querySelector('.product-tabs').addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      let i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      event.preventDefault();
      i = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (i+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
      select(tabs[i].dataset.group); tabs[i].focus();
    });
    select('favorites');
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

